import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "p-dialog-title" }
const _hoisted_2 = { class: "-royalBlue" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Alert = _resolveComponent("Alert")

  return (_openBlock(), _createBlock("div", null, [
    (!!_ctx.alert.content)
      ? (_openBlock(), _createBlock(_component_Alert, {
          key: 0,
          alert: _ctx.alert,
          "onUpdate:alert": _cache[1] || (_cache[1] = ($event: any) => (_ctx.alert = $event)),
          isConfirm: true
        }, {
          title: _withCtx(() => [
            _createVNode("span", _hoisted_1, [
              _createVNode("span", _hoisted_2, _toDisplayString(_ctx.resObject.ProductName), 1),
              _createTextVNode(" " + _toDisplayString(_ctx.t('pay')), 1)
            ])
          ]),
          _: 1
        }, 8, ["alert"]))
      : _createCommentVNode("", true)
  ]))
}